import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { ScenarioGrant } from '../../types/scenario-modeling.types';
import { useAppQuery } from '../use-app-query.hook';

export const useScenarioSars = ({
  scenarioId,
  numberOfFetchedItems = 100,
  currentPage = 1,
}: {
  currentPage?: number;
  numberOfFetchedItems?: number;
  scenarioId: string;
}) => {
  const queryClient = useQueryClient();
  const skip = (currentPage - 1 <= 0 ? 0 : currentPage - 1) * numberOfFetchedItems;
  const { data, isLoading, refetch } = useAppQuery<
    { data: ScenarioGrant[]; totalPages: number },
    HttpException
  >({
    queryKey: [
      QueryKey.GET_SCENARIOS_SARS,
      {
        page: currentPage,
        skip,
        numberOfFetchedItems,
      },
    ],
    queryFn: () =>
      ApiService.get(
        { endpoint: BackendRoute.SCENARIOS, routePath: [scenarioId, 'grants'] },
        {
          queryParams: {
            take: numberOfFetchedItems,
            skip,
            sarOnly: true,
          },
        },
      ),
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SCENARIOS_SARS] });
  }, [queryClient]);

  return {
    invalidateQuery,
    scenarioSars: data?.data,
    totalPages: data?.totalPages,
    isLoading,
    refetch,
  };
};
